import Link from 'next/link';

import { ICardAction } from '@/src/utils/collections/cards.mapper';
import { InputSearchDestinations } from '@/src/components/input-search-destinations/InputSearchDestinations';
import { ILocaleType } from '@/src/types';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { DownloadButtons } from '@/src/components/ui/DownloadButtons/DownloadButtons';
import { EmailButton } from '@/src/components/ui/EmailButton/EmailButton';

interface ICardActionProps {
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  action: ICardAction;
  locale: ILocaleType;
}

export const CardAction = ({
  action,
  locale,
  destinations,
}: ICardActionProps) => {
  if (action.type === 'search') {
    return (
      <div
        className={
          'flex w-full max-w-lg flex-col items-center justify-center gap-8'
        }
      >
        <InputSearchDestinations
          destinations={destinations}
          placeholder={action.data.placeholder}
          icon={action.data.icon}
        />
      </div>
    );
  } else if (action.type === 'redirection') {
    return (
      <Link
        className={
          'mt-16 rounded-5xl bg-primary px-8 py-5 font-semibold text-white no-underline active:bg-primary-dark'
        }
        href={`/${locale.locale}/${action.data.url}`}
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_button',
            click_id: `/${locale.locale}/${action.data.url}`,
            click_label: action.data.text,
          });
        }}
      >
        {action.data.text}
      </Link>
    );
  } else if (action.type === 'download') {
    return (
      <DownloadButtons
        linkToAppStore={action.data.linkToAppStore}
        linkToPlayStore={action.data.linkToPlayStore}
      />
    );
  } else if (action.type === 'contact') {
    return (
      <EmailButton
        email={action.data.email}
        text={action.data.contactButton}
        subject={action.data.subject}
      />
    );
  }
};
